import React from 'react';
import { ApolloClient, createNetworkInterface, ApolloProvider } from 'react-apollo';
import { connect } from 'react-redux';

import CoreLayout from './layouts/PageLayout/PageLayout';
import ViewSchedulerRoute from './routes/ViewScheduler';
import TimeSlotSelectRoute from './routes/SelectSlot';
import RejectSessionRoute from './routes/SessionReject';
import CancelSessionRoute from './routes/CancelSession';
import SessionHistoryRoute from './routes/SessionHistory';

const mapStateToProps = (state) => ({
  authedUserID: (typeof state.auth.sub !== 'undefined') ? state.auth.sub : null,
  authedUser: state.auth || null,
});

export const createRoutes = (store) => {
  return ({
    path: 'scheduler',
    component: connect(mapStateToProps)(props => {
      console.log(props);

      let GraphQLURI = __GraphQLPublic || publicEndpoint; // eslint-disable-line no-undef
      if (props.authedUserID !== null) {
        GraphQLURI = __GraphQLProtected || protectedEndpoint; // eslint-disable-line no-undef
      }

      let ApolloNetworkInstance = createNetworkInterface({
        uri: GraphQLURI,
        opts: {
          headers: {
            'Authorization': 'Bearer ' + (props.authedUser.rawToken || 'unauthed'),
          }
        }
      });

      let ApolloClientInstance = new ApolloClient({
        networkInterface: ApolloNetworkInstance,
      });

      return (
        <ApolloProvider client={ApolloClientInstance}>
          <CoreLayout store={store} {...props} />
        </ApolloProvider>
      );
    }),
    indexRoute: ViewSchedulerRoute(store),
    childRoutes: [
      TimeSlotSelectRoute(store),
      RejectSessionRoute(store),
      CancelSessionRoute(store),
      SessionHistoryRoute(store),
    ]
  });
};

export default createRoutes;



// WEBPACK FOOTER //
// ./src/routes/scheduler/index.js